module.exports = __webpack_public_path__ + "img/Profil_VP-Ultraline_Alu.9ed3a8b5.jpg";